/**
* Result step 2: Price calculations. 
*/

import { langDict } from "./dict";
import { beautifyPrice, dId, dQS, dQSa, logger, setHform } from "./utils";
import { reservaD, IVA, comsillas, } from "./variables";


function drawPaymentBreakdownBox(y: string = "yes") {

	logger("draw BreakdownBox", "log");	

	let HTMLtotal = ""; 
	let roundedDecimalPayOficina = 0;

	// REmove one-way surcharge:
	if (reservaD[8] < 1) {	reservaD[27] = 0; }

	// Precio_suplementos:
	if (isNaN(reservaD[31]) ) { reservaD[31] = 0; }

	// Precio descuentos:
	if (isNaN(reservaD[33]) ) { reservaD[33] = 0; }


	// Precio Alquiler: 
	reservaD[60] = reservaD[26]*reservaD[5] + reservaD[27];

	// Total Precio Suplementos:
	reservaD[61] = reservaD[47] + reservaD[50] + reservaD[31] - reservaD[33];

	// IVA Cost: 
	reservaD[62] = ( reservaD[60] + reservaD[61] ) * IVA;

	// Precio Final con IVA: 
	reservaD[63] = reservaD[60] + reservaD[61] + reservaD[62];

	// Pago Parcial: 
	reservaD[64] = 0;

	// If commission added to price: 
	if (reservaD[28] > 0) {
		
		reservaD[75] = 1;		// Pago Previo
		reservaD[76] = 0;		// Pago oficina
		
		// 2021-07-01 - Add commision part for extras - 
		// This is only for ones where commission is passed in JSON:
		// Base commission + Sillas.

		// Pago Parcial Importe (comission + sillas): 
		reservaD[64] = ( reservaD[28]*reservaD[5] + reservaD[31]*comsillas/(1+comsillas) )* (1+IVA);  				

	// Pago previo true AND Pago parcial % > 0:
	
	} else if (reservaD[75] == 1 && reservaD[78] > 0) {

		reservaD[64] = reservaD[63] * reservaD[78]/100;

	}


	if (reservaD[64] > 0) {

		// Allow for some wiggle room on commission for rounding errors: 
		if (Math.abs(reservaD[63] - reservaD[64]) <= 0.03) {
			roundedDecimalPayOficina = 0;
		} else {
			roundedDecimalPayOficina = reservaD[63] - reservaD[64];
		}

	} else {

		// In case it is a negative number from discount calculations: 	
		reservaD[64] = 0;
	
	}

	HTMLtotal += `<header>${langDict[39]}</header>
								<p>${langDict[48]}</p>
								<span class='price'>
									${langDict[40]} ${beautifyPrice(roundedDecimalPayOficina + reservaD[64])}
									 <br><small>${langDict[97]}</small></span>
								<div>
									<div>
										<header>${langDict[41]}</header>
										<span class="price">${beautifyPrice(reservaD[64])}</span>
									</div>
									<div>
										<header>${langDict[42]}</header>
										<span class="price">${beautifyPrice(roundedDecimalPayOficina)}</span>
									</div>
								<div>`;


	(<HTMLElement>dId("pagoPrevPrice")).innerHTML = HTMLtotal;
	(<HTMLElement>dId("pagoPrevPrice")).classList.remove("hidden");

	check_show_flight();
	setHform();

	if (y == "yes") {

		(<HTMLElement>dId("resFormDiv")).classList.remove("hidden");
		let scroll_loc = (<HTMLElement>dId("resFormDiv")).offsetTop - document.body.scrollTop;
		document.body.scrollTop = scroll_loc;
	}


}


function check_show_flight() {
		
	let reqFlight = "";
	let flight_div = <HTMLElement>dId("form_vuelo");
	
	if (reservaD[40] == "MADT61" || reservaD[40] == "BCNT61") {

		reqFlight = "f_vuelo";
		flight_div.style.display = "inline-flex";

	} else if (reservaD[12].indexOf("eropuerto") > 0) {

		reqFlight = "";
		flight_div.style.display = "inline-flex";

	} else {

		reqFlight = "";
		flight_div.style.display = "none";

	}

}


/** Draw price to screen - refreshed after each update of variable options */
function showPrice() {

	let km_dia:string;
	let km_txt:string;
	let owtx:string; // one way text. Not used in this function, but present for other code
	let chgow:number; 
	let cuota:number;

	let targets = dQSa(".fPrice");


 [km_dia, km_txt, chgow, cuota, owtx] = calcPrice();

	// ! The div this references is not present in HTML: Maybe Rentoauto? 
	if (cuota > 0) {

		let chgofi_s = 0;
		let sup_s = "";
		let chgofi_d = 0;
		let sup_d = ""

		// ! Not sure if this is used (supplement for office)?
		if (reservaD[47] > 0) {
			chgofi_s = reservaD[47]*(1+IVA);
			sup_s = "<br><strong>" + langDict[33] + "</strong> " + beautifyPrice(chgofi_s)
		}
		
		// ! Not sure if this is used (supplement for office)?
		if (reservaD[50] > 0) {
			chgofi_d = reservaD[50]*(1+IVA);
			sup_d = "<br><strong>" + langDict[34] + "</strong> " + beautifyPrice(chgofi_d)
		} 

		let d = "<strong>" + langDict[35] + "</strong>" + beautifyPrice(cuota) + " / día " + owtx + sup_s + sup_d + "</p>";
		
		// ! DOES NOT EXIST: Maybe desglose of charges where we dont have breakdown table:
		// (<HTMLElement>dQS(".carDats .desglose") ).innerHTML = d;

	}

	targets.forEach( (el) => {
		el.innerHTML = beautifyPrice( reservaD[26] * reservaD[5]*(1+IVA) + chgow) + " <span class='ivainc'>" + langDict[16] + "</span>";
	});

}



// Price breakdown in separate div (resDesglose)
function drawPresupuestoBox(): void {

	logger("drawPresupuestoBox", "log");

	// Zero precio sup if not set: 
	if ( !reservaD[31] || isNaN(reservaD[31]) ) { reservaD[31] = 0; }
	if ( !reservaD[33] || isNaN(reservaD[33])) { reservaD[33] = 0; }	// Discounts - not used right now.
	
	setHform();

  const cuota_dia = (reservaD[26]).toFixed(2);
  const cuota_total = (reservaD[26] * reservaD[5]).toFixed(2);
  const extras = (reservaD[31] + reservaD[27]).toFixed(2);
  const iva = ( (reservaD[26] * reservaD[5] + (reservaD[31] + reservaD[27])) * IVA ).toFixed(2);
  const tot_iva = ( (reservaD[26] * reservaD[5] + reservaD[31] + reservaD[27] )*(1+IVA) ).toFixed(2);

	let km_dia = (reservaD[25]/reservaD[5]).toFixed(0);
	let km_max = reservaD[29];

	// Km ilimitada:
	if (reservaD[25] > 99998) {
		km_dia = langDict[91];
	}

	if (reservaD[29] > 99998) {
		km_max = langDict[91];
	}

  var desDiv = `
	<h2>${langDict[110]}</h2>
	<div>
		<table class='desglose'>
			<tr><th>${langDict[111]}</th><td>${reservaD[5]}</td></tr>
			<tr><th>${langDict[112]}/${langDict[113]}</th><td>${km_dia}</td></tr>
			<tr><th>${langDict[112]} ${langDict[114]}</th><td>${km_max}</td></tr>
			<tr><th>${langDict[115]}/${langDict[113]}</th><td>${cuota_dia}€</td></tr>
		</table>
	</div>
	<div> 
		<table class='desglose'>
			<tr><th>${langDict[115]} ${langDict[114]}</th><td>${cuota_total}€</td></tr>
			<tr><th>${langDict[115]} ${langDict[116]}</th><td>${extras}€</td></tr>
			<tr><th>${langDict[118]}</th><td>${iva}€</td></tr>
			<tr><th><strong>${langDict[117]} ${langDict[16]}</strong></th><td><strong>${tot_iva}€</strong></td></tr>
		</table>
	</div>
	<div class='breakout'> </div>`;


	(<HTMLElement>dId("resDesglose")).innerHTML = desDiv;


}


/**
 * 
 * @returns [km_dia string, km_txt string, chgow, cuota, ow_text]
 */

function calcPrice() : [string, string, number, number, string]{

	let chgow = 0;
  let owtx = "";

  let km_dia = Math.floor(reservaD[25]/reservaD[5]) + "km. ";
	let km_txt = reservaD[25] + "km. ";

	const numb = String( reservaD[25] ).match(/\d/g);

  const cuota = reservaD[26] * (1 + IVA);
	
	if (reservaD[8] == 1 && reservaD[27] > 0) {
		chgow = reservaD[27]*(1+IVA);
		owtx = " + OneWay: " + beautifyPrice(chgow)
	} else {
		owtx = "";
		chgow = 0
	}


	if (numb && numb.length > 1) {
    let numb_val = parseInt(numb.join(""));
    if (numb_val >= 99998) {
      km_dia = km_txt = langDict[91];
    }
  }

	 // Km incluidos / Dia / Max:
	 if (reservaD[29] !== undefined && reservaD[29] < reservaD[25] && reservaD[25] < 99998) {
    km_txt = reservaD[29] + "Km. max";
    km_dia = Math.floor(reservaD[29]/reservaD[5]) + " Km.";
  }


	return [km_dia, km_txt, chgow, cuota, owtx];

}



export { drawPaymentBreakdownBox as drawPaymentBreakdownBox, calcPrice, showPrice, drawPresupuestoBox };
